var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import { Alert, Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useWizard } from '../../../components/Wizard/useWizard';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { CardSocio } from '../components/CardSocio';
import { useProcessContext } from '../context/ProcessContext';
import { SocioModalForm } from './SocioModalForm';
export var SociosForm = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useWizard(), nextStep = _c.nextStep, prevStep = _c.prevStep;
    var _d = useProcessContext(), processo = _d.processo, addSocio = _d.addSocio, updateSocio = _d.updateSocio, deleteSocio = _d.deleteSocio, analise = _d.analise, isLoading = _d.isLoading;
    var _e = useState(null), modalSocioOpen = _e[0], setModalSocioOpen = _e[1];
    var _f = useState(undefined), selectedSocio = _f[0], setSelectedSocio = _f[1];
    var socios = processo === null || processo === void 0 ? void 0 : processo.socios;
    var handleOpenAddSocio = function () {
        setModalSocioOpen('adicionar');
    };
    var handleOpenEditSocio = function (socio) {
        setSelectedSocio(socio);
        setModalSocioOpen('editar');
    };
    var handleOpenViewSocio = function (socio) {
        setSelectedSocio(socio);
        setModalSocioOpen('visualizar');
    };
    var handleCloseModal = function () {
        setModalSocioOpen(null);
        setSelectedSocio(undefined);
    };
    var handleSaveSocio = function (socio) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedSocio) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateSocio(selectedSocio.id, socio)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addSocio(socio)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setModalSocioOpen(null);
                    setSelectedSocio(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteSocio = function (socioId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteSocio(socioId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, children: [_jsx(Typography, { variant: "h6" }), !disabled && (_jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: handleOpenAddSocio, children: "Adicionar S\u00F3cio(a)" }))] }), (!socios || socios.length === 0) && (_jsx(Alert, { severity: "warning", sx: { mt: 2 }, children: "Voc\u00EA ainda n\u00E3o realizou o cadastro de nenhum S\u00F3cio(a). Clique no bot\u00E3o \"Adicionar S\u00F3cio(a)\" para cadastrar S\u00F3cios(as)." })), !!socios &&
                socios.length > 0 &&
                socios.map(function (socio) { return (_jsx(CardSocio, { socio: socio, analise: analise, onOpenEdit: handleOpenEditSocio, onOpenView: handleOpenViewSocio, onDelete: handleDeleteSocio, disabled: disabled }, socio.id)); }), !!modalSocioOpen && (_jsx(SocioModalForm, { modo: modalSocioOpen, open: true, socio: selectedSocio, onClose: handleCloseModal, onSave: handleSaveSocio })), _jsx(WizardButtons, { nextClick: function () { return nextStep(); }, prevClick: function () { return prevStep(); }, isSubmitting: isLoading })] }));
};
